import React from 'react';

import { CircularProgress, Grid } from '@mui/material';
import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  container: {
    paddingTop: 60,
  },
}));

export function LoadingState({ className }: React.HTMLAttributes<HTMLElement>): JSX.Element {
  const { classes } = useStyles();

  return (
    <Grid
      container
      className={clsx(classes.container, className)}
      sx={{
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      <CircularProgress />
    </Grid>
  );
}
